import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconInProgressStyle0 = cosmosIconCss;

const CosmosIconInProgress = /*@__PURE__*/ proxyCustomElement(class CosmosIconInProgress extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8990f22355cf68111e078bf29918e955e40d0710', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '693350b4a270138eb833cc20999090291f422f01', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f0a660575a2eb9f1350548ee2771ce143661b5b3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.75 2a.75.75 0 0 0-.75.75v16.5c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75V2.75a.75.75 0 0 0-.75-.75H2.75Z", fill: "currentColor" }), h("path", { key: '2d1495766e2edb620ae6d332c335db0f30bb2efd', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m8.595 15.098 6.605-3.757a.387.387 0 0 0 .18-.338.386.386 0 0 0-.18-.339L8.596 6.907a.271.271 0 0 0-.315.015.392.392 0 0 0-.143.33v7.515c.002.129.06.247.152.314a.276.276 0 0 0 .306.017Z", fill: "#fff" }))));
    }
    static get style() { return CosmosIconInProgressStyle0; }
}, [1, "cosmos-icon-in-progress", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-in-progress"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-in-progress":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInProgress);
            }
            break;
    } });
}

export { CosmosIconInProgress as C, defineCustomElement as d };
